module.exports = "/build/web/svg/sponsor/x-ict-wit.d42a4b90578547d3019c81852b1c23f1.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/x-ict-wit.svg
// module id = 227
// module chunks = 24